import React, { useCallback, useEffect, useState } from 'react';
import { ItemFilter } from '../ItemFilter';
import { FilterItems } from '../../../../models/Specialist';
import * as S from './styles';

const ChevronImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg';

interface AccordionProps {
  title: string;
  hasBorder?: boolean;
  data: FilterItems[];
  isMultipleSelect?: boolean;
  onSelectItem: (items: string[]) => void;
  selectedFilters: string[];
  isVisible: boolean;
  alreadySelectedFilters: string[];
}

const Accordion = ({
  title,
  hasBorder,
  data,
  isMultipleSelect,
  onSelectItem,
  selectedFilters,
  alreadySelectedFilters,
  isVisible
}: AccordionProps) => {
  const [selectItems, setSelectedItems] = useState<string[]>([]);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleSelectItem = (itemId: string | string[]) => {
    if (Array.isArray(itemId)) {
      if (!selectedFilters.length) {
        setSelectedItems([]);
      } else {
        setSelectedItems(itemId);
      }
    } else {
      let result;
      const lookedItemItem = selectItems.findIndex(id => id === itemId);

      if (lookedItemItem > -1) {
        const filteredItem = selectItems.filter((_, index) => lookedItemItem !== index);
        result = filteredItem;
      } else isMultipleSelect ? (result = [...selectItems, itemId]) : (result = [itemId]);

      setSelectedItems(result);
      onSelectItem(result);
    }
  };

  useEffect(() => {
    handleSelectItem(selectedFilters);
  }, [selectedFilters]);

  useEffect(() => {
    if (isVisible) {
      if (alreadySelectedFilters.length) setIsAccordionOpen(true);
      else setIsAccordionOpen(false);
    }
  }, [isVisible, alreadySelectedFilters]);

  return (
    <>
      {data.length > 0 && (
        <S.Container isOpen={isAccordionOpen} hasBorder={hasBorder}>
          <S.Row
            onClick={() => {
              setIsAccordionOpen(!isAccordionOpen);
            }}
          >
            <S.Title>{title}</S.Title>
            <div id={isAccordionOpen ? 'active' : 'not_active'} onClick={() => {}}>
              <img src={ChevronImg} alt="chevron" />
            </div>
          </S.Row>
          <S.DataListContainer isOpen={isAccordionOpen}>
            {data.map((item, index) => (
              <ItemFilter
                onSelectItem={() => handleSelectItem(item.id)}
                key={item.id + index}
                title={item.name}
                isMultipleSelect={isMultipleSelect}
                isSelected={!!selectItems.find(id => id === item.id)}
              />
            ))}
          </S.DataListContainer>
        </S.Container>
      )}
    </>
  );
};

export default Accordion;
